"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Parser_1 = require("../Parser");

var parserSupport_1 = require("../parserSupport");

var ValidationResult_1 = require("../ValidationResult");
/**
 * Parses boolean from string. True/false literals can be specified.
 *
 * @author Jaroslav Sevcik
 */


var YesNoBooleanParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(YesNoBooleanParser, _Parser_1$Parser);

  function YesNoBooleanParser() {
    var _this;

    var trueLiteral = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YES';
    var falseLiteral = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NO';

    _classCallCheck(this, YesNoBooleanParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(YesNoBooleanParser).call(this));
    _this.trueLiteral = trueLiteral;
    _this.falseLiteral = falseLiteral;
    return _this;
  }

  _createClass(YesNoBooleanParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (input === this.trueLiteral) {
        return parserSupport_1.succ(true);
      }

      if (input === this.falseLiteral) {
        return parserSupport_1.succ(false);
      }

      return new ValidationResult_1.ValidationError(parserSupport_1.BAD_ENUM_VALUE_ERROR, this.trueLiteral + '/' + this.falseLiteral);
    }
  }]);

  return YesNoBooleanParser;
}(Parser_1.Parser);

exports.YesNoBooleanParser = YesNoBooleanParser;